import { createSlice } from "@reduxjs/toolkit";

const initialState = { recommendedOrgsBanner: true, deloitteUSBanner: true, deloitteDefaultBanner: true };

export const homeBannerSlice = createSlice({
  name: "homeBanner",
  initialState,
  reducers: {
    setOpen: (state, action) => {
      if (action.payload.recommendedOrgsBanner !== undefined) {
        state.recommendedOrgsBanner = action.payload.recommendedOrgsBanner;
      }
      if (action.payload.deloitteUSBanner !== undefined) {
        state.deloitteUSBanner = action.payload.deloitteUSBanner;
      }
      if (action.payload.deloitteDefaultBanner !== undefined) {
        state.deloitteDefaultBanner = action.payload.deloitteDefaultBanner;
      }
    },
  },
});

export const { setOpen } = homeBannerSlice.actions;
